import React, {useEffect} from "react";
import {ErrorBoundary} from "react-error-boundary";
import {Alert, Button} from "antd";
import {ReloadOutlined} from "@ant-design/icons";
import * as Sentry from "@sentry/nextjs";
import {DEBUG} from "../../config";
import {getPurOrg} from "../../utils";
import { t } from "@lingui/core/macro";

export default function LayoutError(props){

    const onError=(err)=>{
        if(!DEBUG){
            Sentry.withScope((scope)=>{
                scope.setTag("Client","ErrorBoundary")
                scope.setExtra("page",JSON.stringify(props.context?.page))
                scope.setExtra("orgId",props.context?.org?.id)
                scope.setExtra("orgName",props.context?.org?.name)
                Sentry.captureException(err)
            })
        }
    }

    return (
        <ErrorBoundary fallbackRender={fallbackRender} onError={(err)=>onError(err)}>
            {props.children}
        </ErrorBoundary>
    )
}

function fallbackRender({ error, resetErrorBoundary }) {

    return (
        <div style={{height:"100vh",display:"flex",alignItems:"center",justifyContent:"center"}}>
            <Alert
                style={{minWidth:"50%"}}
                showIcon
                message={t`Une erreur est survenue`}
                description={<div dangerouslySetInnerHTML={{__html:error.message.replaceAll("\n","<br/>")}}/>}
                type="error"
                action={
                    <Button
                        size="small"
                        type="ghost"
                        onClick={resetErrorBoundary}
                        icon={<ReloadOutlined/>}>
                        {/* t`` (singleton i18n) et PAS <Trans> : ce fallback d'ErrorBoundary
                            remplace tout le sous-arbre, LinguiClientProvider compris — un
                            <Trans> y planterait faute de contexte, et masquerait l'erreur
                            qu'on essaie justement d'afficher. */}
                        {t`Recharger la page`}
                    </Button>
                }
            />

        </div>
    );
}
